module.exports = __webpack_public_path__ + "img/active-video-nav-title.549471e0.png";